import useStore from "components/ui/Context"
function NotiCation() {
  const { togleModalLogin } = useStore()

  function handerShowModal() {
    togleModalLogin()
  }

  return (
    <div className="fixed w-full right-0 lg:top-16 z-0 top-12">
      <div className="px-2 md:px-10 2xl:px-12 flex justify-end md:mr-16">
        <div className="w-full md:w-[524px] rounded-b-lg bg-[#0E1E3E]">
          <div className="p-4">
            <div className="flex  p-1">
              <div className="text-lg font-semibold flex">THÔNG BÁO</div>
            </div>
          </div>
          <div style={{ borderTop: "solid 1px rgb(55 65 81)", opacity: "0.8" }}></div>
          <div className="bg-dark-500 w-full px-12 py-4 rounded-b-lg">
            <div className="text-base  text-dark-100 font-medium mb-2 col-span-10 flex items-center justify-center text-center">
              <div>
                Vui lòng{" "}
                <span className="text-primary-500 cursor-pointer" onClick={handerShowModal}>
                  ĐĂNG NHẬP
                </span>{" "}
                để nhận những thông báo mới nhất từ ON Plus
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default NotiCation
